import { FieldPath, UseFormReturn } from "react-hook-form";

import { SaveIndicator } from "./SaveIndicator";
import { useSaveIndicator } from "@/hooks/useSaveIndicator";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { cn } from "@/lib/utils";

export const AutosaveFormNumberSelect = <T extends Record<string, unknown>>({
  className,
  fieldName,
  form,
  label,
  onSelect,
  options,
}: {
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  label: string;
  onSelect: () => Promise<void> | void;
  options: { value: number; label: string }[];
}) => {
  const { status, trigger } = useSaveIndicator();

  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            <FormLabel className="inline-flex w-full items-center justify-between">
              {label}
              <SaveIndicator status={status} />
            </FormLabel>
            <Select
              onValueChange={(value) => {
                field.onChange(Number(value));
                trigger(onSelect());
              }}
              value={field.value ? (field.value as number).toString() : ""}
            >
              <FormControl>
                <SelectTrigger className="bg-slate-50 text-black focus:border-slate-400">
                  <SelectValue placeholder="-" />
                </SelectTrigger>
              </FormControl>
              <SelectContent className="text-slate-700">
                {options.map((option) => (
                  <SelectItem
                    key={option.value}
                    value={option.value.toString()}
                  >
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
